import { Kind } from '../../../types/session'

export const sessionBase = { description: '', kind: Kind.Presencial, date: new Date(), spots: 0, color: '', branch: '', subject: '', teacher: '' }
export const kindOptions = [{ label: 'Presencial', value: 0 }, { label: 'Online', value: 1 }]
